import { Box, styled } from '@mui/material';

export const AnimatedReveal = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
	overflow: 'hidden',
	maxHeight: open ? 100 : 0,
	opacity: open ? 1 : 0,
	transition: 'all 500ms ease',
}));
